document.addEventListener('DOMContentLoaded', () => {
	let accordions = document.querySelectorAll('.notifiableConditions .card')

	accordions.forEach(accordion => {
		const summary = accordion.querySelector('.summary')
		const details = accordion.querySelector('.details')

		accordion.setAttribute('style', `--open-height: ${details.scrollHeight}px;`)

		summary.addEventListener('click', () => {
			accordion.classList.toggle('open')
		})

		window.addEventListener('resize', () => {
			accordion.setAttribute('style', `--open-height: auto;`)
			accordion.setAttribute(
				'style',
				`--open-height: ${details.scrollHeight}px;`
			)
		})
	})
})
